import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema } from "./validation.ts";

/*
Der Webservice fdw_gid ermittelt zu einer PLZ die zugehörigen Gemeinde-Parameter. 
Es wird ein Array von Gemeinden zurückgegeben. Das dabei zurückgegebene Objekt enthält
neben dem für die weitere Anfrage relevanten Parameter gemeinde_id auch noch 
Zusatzinformationen, wie der Name des Bundeslandes, des Verbundes, 
des Kreises und der Gemeinde selbst, die für die weiteren Abfragen nicht relevant sind, 
dem Onlinenutzer jedoch als Information angezeigt werden können.
*/

export interface Evu {
    id: 'string',
    name: 'string',
    info: 'Grundversorger' | 'Standard'
};

export type FDWEvuidResponse = Array<Evu>;

export class FDWEvuid extends Request<FDWEvuidResponse>{
    method : TRequestMethod = "GET";
    responseSchema : Schema = {
        Evu: [{
            id: 'string',
            name: 'string',
            info: 'string'
        }]
    };

    constructor (
        public session_id: string,
        public gemeinde_id: number,
        public evu_type: Array<number> = []
    ){
        super();
    }

    route() : string{
        return `${BASEURL}/fdw_evuid/${this.session_id}/${this.gemeinde_id}` + (this.evu_type.length > 0 ? `/${this.evu_type.join(',')}` : '/1');
    }
}